import React, { FormEvent } from 'react';

import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react';

import { apiStatusStore } from '../../../../../shared/stores/apiStatusStore';

type CheckoutFormProps = {
  formId: string;
  entityId: number;
  onPaymentSuccess: () => void;
};

const CheckoutForm = observer(({ formId, onPaymentSuccess }: CheckoutFormProps) => {
  const stripe = useStripe();
  const elements = useElements();

  const confirmPaymentHandler = async () => {
    if (!stripe || !elements) {
      return;
    }

    await elements.submit();

    const { error } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
      confirmParams: {
        // return_url: returnUrl,
      },
    });

    if (error) {
      throw new Error(error.message);
    }
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    apiStatusStore.loadingStart(true);

    try {
      await confirmPaymentHandler();
      onPaymentSuccess();
    } catch (error: any) {
      apiStatusStore.addErrorMessage(error.message);
    } finally {
      apiStatusStore.loadingEnd(true);
    }
  };

  return (
    <form id={formId} onSubmit={handleSubmit}>
      <PaymentElement
        id="card-info-box" // A&A test id
        options={{
          wallets: { googlePay: 'never', applePay: 'never' },
        }}
      />
    </form>
  );
});

export { CheckoutForm };
